import React from 'react';
import DOMPurify from 'dompurify';
import {CGE} from "../../CGE";

function RenderContent({textContent,classname}) {
  
  const [textContentAux, setTextContentAux] = React.useState("");

  React.useEffect(() => {
    if(Array.isArray(textContent) || !textContent || typeof textContent === "object" || textContent?.replaceAll(" ", "") === "ERROR" ) {
      setTextContentAux("");
    } else {
      setTextContentAux(textContent);
    }
  },[textContent])

  return (
    <>
        {textContentAux && textContentAux?.charAt(0) === '<' ?
            <div className={classname} dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                    textContentAux,
                    { USE_PROFILES: { html: true } }
                    ),
                }}
            ></div>
            : textContentAux && textContentAux?.charAt(0) === '{' ?
                <CGE.Text text="* La información no está disponible actualmente, intente recargar la página." />
            :
            <div className={classname} dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                    textContentAux,
                    { USE_PROFILES: { html: true } }
                    ),
                }}
            ></div>
        }
    </>
  )
}

export default RenderContent;
